global.loadHermesDeps = function () {
  require('../assets/javascripts/booking_app/services/hermes/hermes.service');
}
